import { render, staticRenderFns } from "./t-table-row-mobile.vue?vue&type=template&id=47f2b758&scoped=true&lang=pug"
import script from "./t-table-row-mobile.vue?vue&type=script&lang=js"
export * from "./t-table-row-mobile.vue?vue&type=script&lang=js"
import style0 from "./t-table-row-mobile.vue?vue&type=style&index=0&id=47f2b758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2b758",
  null
  
)

export default component.exports